import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { storeContactMessage } from '../services/contactService';
import { useTheme } from '../context/ThemeContext';


const Contact = () => {
    const { theme } = useTheme();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const createCaptcha = () => {
        const a = Math.floor(Math.random() * 9) + 1;
        const b = Math.floor(Math.random() * 9) + 1;
        return { a, b, answer: a + b };
    };
    const [captcha, setCaptcha] = useState(createCaptcha);
    const [captchaInput, setCaptchaInput] = useState('');

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        // Clear error when user types
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus({ type: '', message: '' });
        setErrors({});

        let newErrors = {};
        
        // Basic field validation
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.email && !emailRegex.test(formData.email)) {
            newErrors.email = 'Please provide a valid email address';
        }

        // Captcha validation
        if (!captchaInput || Number(captchaInput) !== captcha.answer) {
            newErrors.captcha = 'Please solve the captcha correctly';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitting(false);
            return;
        }

        try {
            await storeContactMessage(formData);
            setStatus({ type: 'success', message: 'Message sent successfully!' });
            setFormData({ name: '', email: '', message: '' });
            setCaptchaInput('');
            setCaptcha(createCaptcha());
            
            setTimeout(() => {
                setStatus({ type: '', message: '' });
                // window.location.reload(); // Removed reload to prevent navigation issues
            }, 3000);
        } catch (error) {
            console.error('Form submission error:', error);
            setStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <>
            {/* Page Header */}
            <section id="main-banner-page" className="position-relative page-header contact-header section-nav-smooth parallax" style={{ zIndex: 5 }}>
                <div className="overlay overlay-dark opacity-6"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="page-titles whitecolor text-center padding">
                                <h2 className="font-bold"> Contact Us</h2>
                                <h3 className="font-light py-2">We'd Love To Here From You.</h3>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg title-wrap mt-n5">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 whitecolor">
                                <h3 className="float-left">Contact Us</h3>
                                <ul className="breadcrumb top10 bottom10 float-right">
                                    <li className="breadcrumb-item hover-light"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item hover-light">Contact Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Page Header ends */}

            {/* Contact US */}
            <section id="stayconnect1" className="stay-connect-section bglight position-relative padding_top padding_bottom_half noshadow">
                <div className="container whitebox">
                    <div className="widget py-5">
                        <div className="row">
                            <div className="col-md-12 text-center wow fadeIn mt-n3" data-wow-delay="300ms">
                                <h2 className="heading bottom30 darkcolor font-light2 pt-1"><span className="font-normal">Contact</span> Us
                                    <span className="divider-center"></span>
                                </h2>
                            </div>

                            <div className="col-md-6 col-sm-6 order-sm-2">
                                <div className="contact-meta px-2 text-center text-md-left">
                                    <div className="heading-title heading_small">
                                        <h3 className={`${theme === 'dark' ? 'whitecolor' : 'darkcolor'} font-normal mb-4`}>Cherrypik software.com</h3>
                                    </div>
                                    <p className="bottom10">21th Floor, <br />OPP Seema hall, Prahladnagar road,<br /> Ahmedabad, Gujarat 380015 India</p>

                                    <p className="bottom10">Mon-Fri: 8AM-5PM (IST)</p>
                                    <ul className="social-icons mt-4 mb-4 mb-sm-0 wow fadeInUp no-border darkcolor" data-wow-delay="300ms">
                                        <li style={{ marginRight: '15px' }}><a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className=""><i className="fab fa-facebook-f"></i> </a> </li>
                                        <li style={{ marginRight: '15px' }}><a href="https://twitter.com/" target="_blank" rel="noreferrer" className=""><i className="fab fa-twitter"></i> </a> </li>
                                        <li><a href="https://www.linkedin.com/" target="_blank" rel="noreferrer" className=""><i className="fab fa-linkedin-in"></i> </a> </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-6">
                                <div className="heading-title  wow fadeInUp" data-wow-delay="300ms">
                                    <div className="getin_form wow fadeInUp" data-wow-delay="400ms">
                                        <form onSubmit={handleSubmit} className="init" noValidate>
                                            <div className="row px-2">
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <span className="formControlWrap" data-name="your_name">
                                                            <input
                                                                size="40"
                                                                maxLength="400"
                                                                className={`formControl form-control ${errors.name ? 'is-invalid' : ''}`}
                                                                aria-required="true"
                                                                aria-invalid="false"
                                                                placeholder="Name *"
                                                                type="text"
                                                                name="name"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                            />
                                                        </span>
                                                        {errors.name && <div className="text-danger small pl-2 mt-1">{errors.name}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <span className="formControlWrap" data-name="your_email">
                                                            <input
                                                                size="40"
                                                                maxLength="400"
                                                                className={`formControl form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                aria-required="true"
                                                                aria-invalid="false"
                                                                placeholder="Email *"
                                                                type="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                            />
                                                        </span>
                                                        {errors.email && <div className="text-danger small pl-2 mt-1">{errors.email}</div>}
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12">
                                                    <div className="form-group mb-3">
                                                        <span className="formControlWrap" data-name="your_message">
                                                            <textarea
                                                                cols="40"
                                                                rows="5"
                                                                maxLength="2000"
                                                                className="formControl form-control"
                                                                aria-invalid="false"
                                                                placeholder="Message"
                                                                name="message"
                                                                value={formData.message}
                                                                onChange={handleChange}
                                                            ></textarea>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12 mb-4">
                                                    <div className="custom-captcha-wrapper">
                                                        <div className="custom-captcha-box">
                                                            <label className="custom-captcha-label mb-2">
                                                                Verify: {captcha.a} + {captcha.b} = ?
                                                            </label>
                                                            <div className="custom-captcha-row">
                                                                <input
                                                                    type="number"
                                                                    className={`formControl form-control ${errors.captcha ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter answer"
                                                                    value={captchaInput}
                                                                    onChange={(e) => {
                                                                        setCaptchaInput(e.target.value);
                                                                        if (errors.captcha) setErrors(prev => ({ ...prev, captcha: '' }));
                                                                    }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="custom-captcha-refresh"
                                                                    onClick={() => {
                                                                        setCaptcha(createCaptcha());
                                                                        setCaptchaInput('');
                                                                        if (errors.captcha) setErrors(prev => ({ ...prev, captcha: '' }));
                                                                    }}
                                                                    aria-label="Refresh captcha"
                                                                >
                                                                    <i className="fas fa-sync-alt"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {errors.captcha && <div className="text-danger small pl-2 mt-3">{errors.captcha}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-sm-12">
                                                        <input
                                                            className="formControl submit contact_btn button gradient-btn w-100"
                                                            type="submit"
                                                            value={isSubmitting ? "Sending..." : "Send"}
                                                            disabled={isSubmitting}
                                                        />
                                                </div>
                                            </div>
                                            {status.message && (
                                                <div className={`alert ${status.type === 'error' ? 'alert-danger' : 'alert-success'} mt-3`} role="alert">
                                                    {status.message}
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="widget text-center top60 w-100 p-0">
                                <div className="contact-box">
                                    <span className="icon-contact defaultcolor"><i className="fas fa-mobile-alt"></i></span>
                                    <p className="bottom0"><a href="tel:+917622888880"><strong>Sales</strong>: +91 8080808080</a></p>
                                    <p className="d-block"><a href="tel:+918160902071"><strong>Support</strong>: +91 8080808008</a></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4">
                            <div className="widget text-center top60 w-100 p-0">
                                <div className="contact-box">
                                    <span className="icon-contact defaultcolor"><i className="far fa-envelope"></i></span>
                                    <p className="bottom0"><a href="mailto:sales@tnowindia.in"><strong>Sales</strong>: sales@.in</a></p>
                                    <p className="d-block"><a href="mailto:cs@tnowindia.in"><strong>Support</strong>: cs@.in</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="widget text-center top60 w-100 p-0">
                                <div className="contact-box">
                                    <span className="icon-contact defaultcolor"><i className="far fa-clock"></i></span>
                                    <p className="bottom15">Monday - Friday <span className="d-block">8AM-5PM (IST)</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>
    );
};

export default Contact;
